import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomersService } from 'app/services/customer/customers.service';
import { ConfirmationService, Message, MessageService, SelectItem } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { Permission, PermissionConfiguration, ApiMethods } from '../../../models/permission.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { CustomersAdminService } from '../../../services/customer/customers-admin.service';
import { AuthService } from '../../../services/user/auth.service';
import { PermsService } from '../../../services/utils/perms.service';
import { SourceSystemService } from './../../../services/source-system/source-system.service';
import * as FileSaver from 'file-saver';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
  selector: 'app-customer-auth-admin',
  templateUrl: 'customers-auth-admin.component.html'
})
export class CustomersAuthAdminComponent implements OnInit {

  // Visualizza dati table di Amministrazione Clienti
  customerAuthPermissions: Permission;

  // Visualizza tasto download file Excel
  public customerExportExcelPermission: boolean;
  public customerExportExcelPermissionCheck: PermissionConfiguration;

  // Disabilita il filtraggio della table per singola colonna
  public staticTable: boolean;
  public staticTableCheck: PermissionConfiguration;

  // Abilita il download del file Excel
  public customerDownloadPermission: boolean;
  public customerDownloadPermissionCheck: PermissionConfiguration;

  // Visualizza button Reset Password
  public showResetPermission: boolean;
  public showResetPermissionCheck: PermissionConfiguration;

  paginationType  = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  listSourceSystem: Array<{ value: string, label: string }>;
  flagItems: SelectItem[];
  cardStates: SelectItem[];
  showDetails = false;
  detailsData: any = null;
  showResetModal = false;
  msgs: Message[] = [];
  newDataAvailable = false;
  selectFilter = KontableComponent.SelectFilter;
  numberFilter = KontableComponent.NumberFilter;
  public showDialog = false;
  public currentRow: any;
  public companyCode: string;
  listTypeCompany: { label: string, value: string }[] = [];

  extSearchResult: any;
  totalRecords: number;
  showGenerateModal = false;
  customerAuthToken = "";
  user: any;

  constructor(
    public svcCustomersAdmin: CustomersAdminService,
    private svcPermission: PermsService,
    private svcSourceSystem: SourceSystemService,
    private svcCustomers: CustomersService,
    private t: TranslateService,
    private svcConfirm: ConfirmationService,
    private svcNotify: MessageService,
    private auth: AuthService,
    private srvLocalStorage: LocalStorageService,
    private router: Router
  ) {

    this.staticTableCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-table-static',
      method: ApiMethods.GET
    };

    this.customerExportExcelPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-auth-export-excel',
      method: ApiMethods.GET
    };

    this.customerDownloadPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-download',
      method: ApiMethods.GET
    };

    this.showResetPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-show-reset',
      method: ApiMethods.GET
    };

    if (this.srvLocalStorage.get('userData')) {
      this.user = this.srvLocalStorage.get('userData');

    } else if (sessionStorage.getItem('userData')) {
      this.user = JSON.parse(sessionStorage.getItem('userData'));
    }
  }

  ngOnInit(): void {

    this.staticTable = true;
    this.customerExportExcelPermission = false;
    this.customerDownloadPermission = false;
    this.showResetPermission = false;

    this.t.get([
      'common.all',
      'common.company',
      'common.physicalPerson'
    ]).subscribe(tr => {
      this.listTypeCompany.push({label: tr['common.all'], value: null});
      this.listTypeCompany.push({label: tr['common.company'], value: 'S'});
      this.listTypeCompany.push({label: tr['common.physicalPerson'], value: 'N'});
    })

    this.listSourceSystem = new Array<{ value: string, label: string }>();

    const perms = this.svcPermission.getPermission({ms_base: 'koncentro-customers', operation: 'customer'});

    const sourceSystemList = this.svcSourceSystem.getList();

    let t_keys = [];
    this.flagItems = [];
    this.cardStates = [];

    this.svcCustomersAdmin.getFlags().forEach(f => {
      t_keys.push('customers.auth_' + f.value)
    });
    t_keys.push('common.all');
    const translations = this.t.get(t_keys);

    let obStaticTableCheck: Observable<any>;
    obStaticTableCheck = this.svcPermission.check(this.staticTableCheck);

    let obCustomerExportExcelPermCheck: Observable<any>;
    obCustomerExportExcelPermCheck = this.svcPermission.check(this.customerExportExcelPermissionCheck);

    let obCustomerDownloadPermCheck: Observable<any>;
    obCustomerDownloadPermCheck = this.svcPermission.check(this.customerDownloadPermissionCheck);

    let obShowResetPermCheck: Observable<any>;
    obShowResetPermCheck = this.svcPermission.check(this.showResetPermissionCheck);

    Observable.zip(
      perms,
      translations,
      sourceSystemList,
      obStaticTableCheck,
      obCustomerExportExcelPermCheck,
      obCustomerDownloadPermCheck,
      obShowResetPermCheck
    ).subscribe( ([permsResult, tResult, resSourceSystem, resStaticTableCheck, resCustomerExportExcelPermCheck, resCustomerDownloadPermCheck, resShowResetPermCheck]) => {
      this.customerAuthPermissions = permsResult;

      this.staticTable = resStaticTableCheck;
      this.customerExportExcelPermission = resCustomerExportExcelPermCheck;
      this.customerDownloadPermission = resCustomerDownloadPermCheck;
      this.showResetPermission = resShowResetPermCheck;

      this.flagItems.push({
        label: tResult['common.all'],
        value: null
      });

      this.cardStates.push({
        label: tResult['common.all'],
        value: null
      });

      this.svcCustomersAdmin.getFlags().forEach(f => {
        this.flagItems.push({
          label: tResult['customers.auth_' + f.value],
          value: '' + f.id
        })
      })

      this.svcCustomersAdmin.getCardStates().forEach(f => {
        this.cardStates.push({
          label: tResult['customers.auth_' + f.value],
          value: '' + f.id
        })
      })

      this.listSourceSystem.push({value: null, label: tResult['common.all']});
      if (resSourceSystem) {
        for (const sourceSystem of resSourceSystem) {
          this.listSourceSystem.push({
            value: sourceSystem.name,
            label: sourceSystem.name
          });
        }
      }

    });

    this.svcPermission.getPermission({ms_base: 'koncentro-customers', operation: 'customer'}).subscribe(permis => {
      this.customerAuthPermissions = permis;
    });

  }

  recoverCustomerAuth(customer) {
    this.svcCustomersAdmin.recoverCustomerAuth(customer).subscribe(() => {
      this.newDataAvailable = true;
    });
  }

  editCustomerAuth(data) {
    console.log('customer auth data', data);
    this.detailsData = data;
    this.showDetails = true;
  }

  deleteCustomerAuth(data) {
    this.svcCustomersAdmin.deleteCustomerAuth(data['id']).subscribe(() => {
      this.t.get([
        'common.confirm',
        'customers.auth_delete_message_confirm'
      ]).subscribe(tr => {
        this.svcNotify.add({severity: 'success', summary: tr['common.confirm'], detail: tr['customers.auth_delete_message_confirm']});
        this.newDataAvailable = true;
      })

    });
  }

  evaluateFlag(flg_state): string {
    return this.svcCustomersAdmin.getFlagKey(flg_state)
  }

  evaluateState(customerCardState): string {
    if (!!customerCardState) {
      return 'customers.auth_' + this.svcCustomersAdmin.getCardStateKey(customerCardState);
    }
    return '';
  }

  onResetAuth(row) {
    this.t.get([
      'common.confirm',
      'common.reject',
      'customers.auth_reset_confirm',
      'customers.auth_reset',
      'customers.auth_reset_message_confirm',
      'customers.auth_reset_message_reject',
    ]).subscribe(tr => {
      this.svcConfirm.confirm({
        message: tr['customers.auth_reset_confirm'],
        header: tr['customers.auth_reset'],
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.svcCustomersAdmin.generateSecurityCodeForPasswordReset({
            accountType: row.account_type_host_id,
            companyCode: this.auth.user.selectedCompany.toString(),
            notifyUser: true,
            sourceCode: row.source_system_host_id,
            userAccount: row.user_account
          }).subscribe( () => {
            this.svcNotify.add({severity: 'success', summary: tr['common.confirm'], detail: tr['customers.auth_reset_message_confirm']});
            this.newDataAvailable = true;
          });
        },
        reject: () => {
          this.svcNotify.add({severity: 'error', summary: tr['common.reject'], detail: tr['customers.auth_reset_message_reject']});
        }
      });
    });
  }

  onClickCustomer(flgCompany, customerId, customer_id) {

    if (flgCompany === 'S') {
      this.router.navigate(['/customer-company', customerId, customer_id]);
    } else {
      this.router.navigate(['/customers-details', customerId, customer_id]);
    }

  }

  onResendActivation(row) {
    this.t.get([
      'common.confirm',
      'common.reject',
      'customers.auth_resend_confirm',
      'customers.auth_resend',
      'customers.auth_resend_message_confirm',
      'customers.auth_resend_activate',
      'customers.auth_resend_message_reject',
    ]).subscribe(tr => {
      this.svcConfirm.confirm({
        message: tr['customers.auth_resend_confirm'],
        header: tr['customers.auth_resend'],
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.svcCustomersAdmin.resendCheckCode({
            accountType: row.account_type_host_id,
            companyCode: this.auth.user.selectedCompany.toString(),
            sourceCode: row.source_system_host_id,
            accountId: row.user_account
          }).subscribe( () => {
            this.svcNotify.add({severity: 'success', summary: tr['common.confirm'], detail: tr['customers.auth_resend_message_confirm']});
          });
        },
        reject: () => {
          this.svcNotify.add({severity: 'error', summary: tr['common.reject'], detail: tr['customers.auth_resend_message_reject']});
        }
      });
    })
  }

  closeDialog() {
    this.showDialog = false;
    this.showGenerateModal = false;
  }

  openResetPassword(event) {
    this.currentRow = event;
    this.companyCode = this.auth.user.selectedCompany.toString();
    this.showDialog = true;
  }

  resetPwdAction(event) {
    this.t.get([
        'common.confirm',
        'customers.auth_reset_confirm'
    ]).subscribe( res => {
      this.svcNotify.add({severity: 'success', summary: res['common.confirm'], detail: res['customers.auth_reset_confirm']});
      this.newDataAvailable = true;
    });
    this.showDialog = false;
  }

  downloadExcel(filters) {
    this.svcCustomersAdmin.getExcelFilename(filters).subscribe(
      filename => {
        if (this.customerDownloadPermission) {
          this.svcCustomers.downloadExcel(filename).subscribe(res => {
            FileSaver.saveAs(res, filename);
          })
        } else {
          return;
        }
      },
      error => console.error(error)
    );
  }

  sendExtSearchQuery(event) {
    /*
      Azzero totalRecords perchè, in caso di svuotamento della table e successiva
      ripetizione della medesima ricerca, il valore non risulterebbe aggiornato e,
      di conseguenza, causerebbe errori di paginazione
    */
    this.totalRecords = 0;
    const params = {query: event.query, offset: event.offset, limit: event.limit};
    if (event.sortField && event.sortDir) {
      Object.assign(params, {sortField: event.sortField, sortDir: event.sortDir});
    }
    this.svcCustomersAdmin.sendExtSearchQuery(params).subscribe(res => {
      this.extSearchResult = res.data;
      this.totalRecords = res.metadata.total;
    });
  }

  openGenerateCustomerAuth(customer) {
    this.svcCustomersAdmin.getCustomerAuthToken(customer).subscribe(res => {
      if(res != null) {
        this.customerAuthToken = res.token;
        this.showGenerateModal = true;
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/admin/customers-auth-admin.component.ts